export const LoadingSpinner = () => {
  return (
    <div
      className="d-flex flex-column gap-2 justify-content-center align-items-center my-4"
      data-testid="loading-spinner"
    >
      <span className="far fa-spin fa-spinner-third" aria-hidden="true" />
      <span className="text-body-secondary">{i18n.t("js.multi_domain_search.loading")}</span>
    </div>
  )
}
